/*
 * @Author: wendong
 * @Date: 2020-06-19 16:43:57
 * @Last Modified by: wendong
 * @Last Modified time: 2020-06-28 16:43:48
 * 遮罩层
 */
import React, { useState, useEffect, useCallback, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import style from "./styles.module.scss";

export default function Shadow({
  zIndex = 99,
  status = false,
  click,
  change,
  children,
}: any) {
  const [count] = useState(0);
  const countRef = useRef(count);

  function clickHandler() {
    click && click(status);
  }

  //打开模态框前调用
  function fixedBody() {
    document.body.style.overflow = "hidden";
    // var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    // document.body.style.cssText += 'position:fixed;top:-' + scrollTop + 'px;';
  }

  //关闭模态框后调用
  function looseBody() {
    var body = document.body;
    body.style.position = "static";
    document.body.style.overflow = "auto";
    // var top = body.style.top;
    // document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top);
    // body.style.top = '';
  }

  function showHandle() {
    // const {body, root, original, afterRootStyle}:any = dataRef.current;
    // original.rootStyle = getRootStyle(afterRootStyle, root);
    // original.scrollTop = root.scrollTop || body.scrollTop;
    // original.scrollLeft = root.scrollLeft || body.scrollLeft;
    // setRootStyle(root, {...afterRootStyle});
    // setRootStyle(body, {...afterRootStyle, top: - original.scrollTop + 'px', left: (original.scrollleft || 0) + 'px'});
    // TODO 凑合一下没时间了
    // body.style.overflow = 'hidden';
    fixedBody();
  }

  function hideHandle() {
    // const {body, root, original} = dataRef.current;
    // // setRootStyle(body, {...initOriginal().rootStyle, top: '', left: '', right: ''});
    // // TODO 凑合一下没时间了
    // body.style.overflow = '';
    // root.scrollTop = body.scrollTop = original.scrollTop;
    // root.scrollLeft = body.scrollLeft = original.scrollLeft;
    // dataRef.current.original = initOriginal();
    looseBody();
  }

  useEffect(() => {
    if (status) {
      showHandle();
    } else {
      hideHandle();
      change && change(false);
    }
    countRef.current = count;
    // if (status) {
    //     setCount(count + 1);
    //     return;
    // }
    // if (count > 0) {
    //     setCount(count - 1)
    // }
  }, [status]);

  // useEffect(() => {
  //     if (countRef.current > 0 && count > 0) {
  //         return;
  //     }

  //     if (count) {
  //         showHandle();
  //     } else {
  //         hideHandle();
  //         change && change(false);
  //     }
  //     countRef.current = count;
  // }, [count]);

  return (
    <CSSTransition
      in={status}
      timeout={1000}
      classNames="fade"
      unmountOnExit={true}
    >
      <div
        className={style["shadow-container"]}
        style={{
          zIndex: zIndex,
        }}
        onClick={() => clickHandler()}
      >
        {children}
      </div>
    </CSSTransition>
  );
}
